<ng-container *ngIf="typeSearch == 'autocomplete'" [ngTemplateOutlet]="searchAutocomplete"></ng-container>
<ng-container *ngIf="typeSearch == 'matSelect'" [ngTemplateOutlet]="searchMatSelect"></ng-container>

<ng-template #searchAutocomplete>
  <ais-instantsearch *ngIf="config" [config]="config">
    <ais-configure #aisConfigure [searchParameters]="configuration"></ais-configure>
    <div class="searchbox">
      <app-algolia-autocomplete [(inputKeyword)]="keyword" [propValue]="propValue" [propDisplay]="propDisplay"
        [configuration]="configuration" (onQuerySuggestionClick)="setValue($event)"
        (onQueryEnter)="onQueryEnter.emit($event)" (onQueryClean)="clickClean()" (onRefresh)="clickRefresh()">
      </app-algolia-autocomplete>
    </div>
  </ais-instantsearch>
</ng-template>

<ng-template #searchMatSelect>
  <ais-instantsearch *ngIf="config" [config]="config">
    <ais-configure #aisConfigure [searchParameters]="configuration"></ais-configure>
    <app-algolia-mat-select [propValue]="propValue" [propDisplay]="propDisplay" [configuration]="configuration"
      [placeholder]="placeholder" [placeholderLabel]="placeholderLabel" [bankControl]="bankControl"
      (onQueryEnter)="onQueryEnter.emit($event)" (onQueryClean)="clickClean()" (onRefresh)="clickRefresh()">
    </app-algolia-mat-select>
  </ais-instantsearch>
</ng-template>

